export default "__VITE_ASSET__sIq$_fNM__"